// extracted by mini-css-extract-plugin
export default {"container":"cL9Y0GXlM","videoContainer":"c1fUw7_Ut","mobile":"ceHz0VklN","block":"cnu27JjXF","description":"cYinz63Ii","categoriesList":"cNT9_nKqk","active":"cPbZ1ZQjn"};